module.exports = __webpack_public_path__ + "img/piazza-benches.b164c29b.webp";